import { formatNumber } from "accounting"

import { formatCurrency } from "../../Utils/utils"

// How a KPI figure reads outside its animated headline (the comparison line, a chart tooltip):
// money in dollars, a rate in whole percent, anything else as a grouped count.
export const formatKpiValue = ({ prefix, suffix }) => {
  if (prefix === "$") return (value) => formatCurrency(value ?? 0, true)
  if (suffix === "%") return (value) => `${formatNumber(value ?? 0, 0, ",", ".")}%`
  return (value) => formatNumber(value ?? 0, 0, ",", ".")
}
